import { useContext } from "react";
import { ProductContext } from "../Context/ProductContext";
import { RoutingContext } from "../Context/Routing.Context";
import { RetailerContext } from "../Context/Retailer.Context";
import { LanguageContext } from "../Context/Language.Context";
import { SFWBuilderContext } from "../Context/BuilderContext";
import { SearchContext } from "../Context/SearchContext";
import { AdminContext } from "../Context/Admin.Context";
import { FeatureDefinitionsContext } from "../Context/FeatureDefinitionsContext";


export const useProductsHook = () => useContext(ProductContext);
export const useRetailerHook = () => useContext(RetailerContext);
export const useLanguageHook = () => useContext(LanguageContext);
export const useRoutingHook = () => useContext(RoutingContext);
export const useSFWBuilderHook = () => useContext(SFWBuilderContext);
export const useSearchHook = () => useContext(SearchContext);
export const useAdminHook = () => useContext(AdminContext);
export const useFeatureDefinitionsHook = () => useContext(FeatureDefinitionsContext)
